<template>
  <div id="app">
    <div id="security_code_wrap">
      <headers v-on:listen="showChild" />
      <div id="login_wrap_denglu">
        <div class="login_wrap_denglu_top">{{school_title}}欢迎学校入驻</div>
        <router-link to="/school-login" class="yanzhengma_enter">已有账号，去登录></router-link>
      </div>
      <div id="security_code_wrap_form">
        <div class="security_code_wrap_form_wrap">
          <div class="security_code_form_wrap_tip">手机号码</div>
          <div class="security_code_form_number">
            <div class="security_code_form_number_left">
              <el-select v-model="value" placeholder="" class="security_code_form_number_left_se" filterable>
                <el-option v-for="item in cities" :key="item.label" :label="item.value" :value="item.value">
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="security_code_form_number_right">
              <el-input v-model="input_content" placeholder="请输入手机号码" class="security_code_form_number_right_int" :class="{'colorerro':colorerro}"></el-input>
            </div>
          </div>
          <div class="number_erro first_erro" :class="{'colordisplays':errodisplay}">
            <div class="number_erro_content">{{numbererro}}</div>
          </div>
          <div class="yanzhengma_bor">
            <div class="yanzhengma_bor_left_infor">
              <el-input v-model="input_yanzhengma" placeholder="请输入验证码" :class="{'yanzhengdisplays':yanzhengdisplays}"></el-input>
            </div>
            <div class="yanzhengma_bor_btn" @click="getCode">
              <el-button class="impro_btn" :class="{'iscursor':iscursor}">获取验证码</el-button>
            </div>
          </div>
          <div class="yanzhengma_erro">
            <div :class="{'yanzheng_test':yanzheng_test}" class="yanzheng_cuowu">{{yanzhengma_con}}</div>
            <div class="yanzheng_time_lodaing" :class="{'yanzheng_loding':yanzheng_loding}">{{time_loging}}秒后可发送</div>
          </div>
          <div class="yanzhengma_bor">
            <div class="your_name">
              <el-input v-model="input_youername" placeholder="请输入你的名称" :class="{'yanzhengdisplays':new_names}" maxlength="10"></el-input>
            </div>
          </div>
          <div class="number_erro new_n_e" :class="{'colordisplays':nameTest}">
            <div class="number_erro_content">请输入名称</div>
          </div>
          <div class="yanzhengma_bor">
            <div class="your_name">
              <el-input v-model="input_yourpass" placeholder="请输入密码(需包含大小写字母和数字)" :class="{'yanzhengdisplays':new_pass}" show-password></el-input>
            </div>
          </div>
          <div class="number_erro new_n_e" :class="{'colordisplays':PWtest}">
            <div class="number_erro_content">长度8-16位，必须包含大小写字母和数字</div>
          </div>
          <div class="yanzhengma_bor">
            <div class="your_name">
              <el-input v-model="input_arram" placeholder="请确认密码" :class="{'yanzhengdisplays':new_arram}" show-password></el-input>
            </div>
          </div>
          <div class="number_erro new_n_e" :class="{'colordisplays':PWend}">
            <div class="number_erro_content">两次输入密码不一致</div>
          </div>
          <div class="login_wrap_for_enter" @click="sub_enter()">
            <div class="login_wrap_for_enter_con">立即注册</div>
          </div>
          <div class="bind-end">绑定手机号，即表示已阅读并同意
            <a href="#">《软件许可及服务协议》</a>和
            <a href="#">《隐私政策》</a>
          </div>
        </div>
      </div>
      <footers/>
    </div>
  </div>
</template>
<script>
import headers from "./header.vue";
import footers from "./footers.vue";
import _ from "lodash";
import Net_Work from "../apis/network.js";
import Address from "../apis/address.js";
import { set_school_join_token } from "../apis/token.js";

import axios from "axios";
import Qs from "qs";

axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;

export default {
  name: "school_join",
  components: { headers, footers },
  data() {
    return {
      value: "+86",
      nameTest: true,
      PWend: true,
      new_arram: false,
      input_arram: "",
      new_pass: false,
      PWtest: true,
      input_yourpass: "",
      isshool: false,
      time_loging: "60",
      new_token: "",
      new_names: false,
      input_yanzhengma: "",
      school_title: "",
      numbererro: "手机号格式错误",
      input_youername: "",
      yanzheng_test: true,
      yanzhengma_con: "验证码错误",
      iscursor: false,
      errodisplay: true,
      yanzheng_loding: true,
      yanzhengdisplays: false,
      colorerro: false,
      input_content: "",
      _conde_ma_key: "",
      cities: Address.citiy
    };
  },
  methods: {
    showChild(data) {
      this.school_title = data;
      window.sessionStorage.setItem("schoolname", this.school_title);
      this.isshool = true;
    },
    haveCode() {
      console.log("nmm");
      this.$router.push("/school-login");
    },
    getCode() {
      var number_quhao = Number(this.value);
      let _this = this;
      var number_true = false;
      if (number_quhao === 86) {
        var repx1 = /^1[012345789]\d{9}$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (repx1.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      } else {
        var rexpx2 = /^[0-9]\d*$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (rexpx2.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      }
      if (number_true) {
        if (this.iscursor) {
          return;
        }
        this.iscursor = true;
        this.yanzheng_loding = false;
        let clock = setInterval(() => {
          this.time_loging--;
          if (this.time_loging < 0) {
            window.clearInterval(clock);
            this.time_loging = 60;
            this.iscursor = false;
            this.yanzheng_loding = true;
          }
        }, 1000);
        axios
          .post(
            "/n/api/sms/send",
            Qs.stringify({
              areaCode: number_quhao,
              phone: this.input_content
            })
          )
          .then(function(response) {
            if (response.data.code == 0) {
              _this._conde_ma_key = response.data.data.key;
              _this.yanzheng_test = true;
              _this.yanzhengdisplays = false;
            } else {
              _this.yanzheng_test = false;
              _this.yanzhengma_con = response.data.msg; /*错误提示文字 */
              _this.yanzhengdisplays = true;
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    sub_enter: _.throttle(function() {
      var number_quhao = Number(this.value);
      var mima_rexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)([^\s]){8,16}$/;
      let _this = this;
      var _erweima = false;
      var number_true = false;
      var text_value = false;
      var text_end = false;
      var text_pass = false;
      if (number_quhao === 86) {
        var repx1 = /^1[012345789]\d{9}$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (repx1.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      } else {
        var rexpx2 = /^[0-9]\d*$/g;
        if (this.input_content.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          return;
        }
        if (rexpx2.test(this.input_content)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
        }
      }
      if (number_true) {
        var rexp_3 = /^[0-9]{6}$/g;
        if (this.input_yanzhengma == "") {
          this.yanzheng_test = false;
          this.yanzhengma_con = "验证码必须是6位数字";
          this.yanzhengdisplays = true;
        } else if (rexp_3.test(this.input_yanzhengma)) {
          this.yanzheng_test = true;
          this.yanzhengdisplays = false;
          _erweima = true;
        } else {
          this.yanzheng_test = false;
          this.yanzhengma_con = "验证码必须是6位数字";
          this.yanzhengdisplays = true;
        }
      }
      if (number_true && _erweima) {
        if (!this._conde_ma_key) {
          this.yanzheng_test = false;
          this.yanzhengma_con = "验证码错误";
          this.yanzhengdisplays = true;
        } else {
          this.yanzheng_test = true;
          this.yanzhengdisplays = false;
          text_value = true;
        }
      }
      if (text_value && number_true) {
        if (!this.input_youername) {
          this.nameTest = false;
          this.new_names = true;
        } else {
          this.nameTest = true;
          this.new_names = false;
          text_pass = true;
        }
      }
      if (text_value && number_true && text_pass) {
        if (mima_rexp.test(this.input_yourpass)) {
          this.new_pass = false;
          this.PWtest = true;
          text_end = true;
        } else {
          this.new_pass = true;
          this.PWtest = false;
        }
      }
      if (text_value && number_true && text_pass && text_end) {
        if (this.input_arram !== this.input_yourpass) {
          this.new_arram = true;
          this.PWend = false;
        } else {
          this.new_arram = false;
          this.PWend = true;
          axios
            .post(
              "/s/api/user/phone/register" /*最新代码位置*/,
              Qs.stringify({
                areaCode: number_quhao,
                code: this.input_yanzhengma,
                key: this._conde_ma_key,
                password: this.input_yourpass,
                password2: this.input_arram,
                phone: this.input_content,
                trueName: this.input_youername
              })
            )
            .then(res => {
              if (res.data.code == 0) {
                // 设置登录token，跳转详情页面
                set_school_join_token(res.data.access_token);
                this.$message({
                  message: res.data.msg,
                  type: "success",
                  duration: 3000,
                  onClose() {
                    _this.$router.push("/school-information");
                  }
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: "error"
                });
              }
            })
            .catch(res => {});
        }
      }
    }, 2000)
  },
  mounted() {},
  created(){
    // 登录注册，全部清空，重新获取
    localStorage.clear();
  }
};
</script>

<style lang="less" scoped>
#security_code_wrap {
  .have_code {
    text-align: center;
    color: #409eff;
    margin-top: 32px;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .bind-end {
    width: 260px;
    margin-left: 50px;
    box-sizing: border-box;
    padding: 0 20px;
    font-size: 14px;
    margin-top: 30px;
  }
  .your_name {
    margin-left: 50px;
    width: 260px;
  }
  .first_erro {
    > div {
      width: 170px !important;
    }
  }
  .new_n_e {
    justify-content: flex-start !important;
    margin-left: 50px;
  }
  #login_wrap_denglu {
    width: 100%;
    height: 155px;
    overflow: hidden;
    background-color: #eee;
    text-align: center;
    .login_wrap_denglu_top.is-user {
      color: #409eff;
    }
    .is-user {
      color: #409eff !important;
    }
    .login_wrap_denglu_top {
      font-family: " MicrosoftYaHei";
      font-size: 30px;
      color: #222743;
      margin-top: 45px;
    line-height: 52px;
    letter-spacing: 1px;
    }

    .yanzhengma_enter {
      color: #066fff;
      font-family: " MicrosoftYaHei";
      margin-top: 10px;
      display: inline-block;
    }
    .user_one {
      > span {
        font-size: 20px;
        line-height: 24px;
        margin-top: 8px;
        display: inline-block;
        color: #ccc;
      }
    }
    .is-user {
      > span {
        color: #409eff;
      }
    }
  }
  #security_code_wrap_form {
    width: 100%;
    padding-bottom: 80px;
    .security_code_wrap_form_wrap {
      width: 360px;
      height: auto;
      margin: 0 auto;
      margin-top: 36px;
      .security_code_form_wrap_tip {
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        color: #999999;
        margin-left: 50px;
      }
    }
    .iscursor {
      cursor: no-drop;
    }
    .colordisplays {
      visibility: hidden;
    }
    .yanzheng_test {
      visibility: hidden;
    }
    .yanzheng_loding {
      visibility: hidden;
    }
    .security_code_form_number {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-top: 10px;
    }
    .security_code_form_number_left {
      margin-left: 50px;
      .security_code_form_number_left_se {
        width: 80px;
        height: 30px;
      }
    }
    .security_code_form_number_right {
      margin-right: 50px;
      width: 170px;
    }
    .yanzheng_code {
      font-family: "MicrosoftYaHei";
      font-size: 14px;
      color: #999999;
      margin-top: 3px;
      margin-left: 50px;
    }
    .number_erro {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin-top: 3px;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: flex-end;
      .number_erro_content {
        margin-right: 50px;
        width: auto;
        font-size: 14px;
        color: #f56c6c;
        font-family: "MicrosoftYaHei";
      }
    }
    .yanzhengma_bor {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-top: 10px;
      .yanzhengma_bor_left_infor {
        margin-left: 50px;
        width: 170px;
        height: 30px;
      }
      .yanzhengma_bor_btn {
        margin-right: 50px;
        .impro_btn {
          width: 87px;
          line-height: 30px;
          display: block;
          padding: 0px;
          text-align: center;
          font-size: 14px;
          color: #3366ff;
          border-color: #cccccc;
        }
      }
    }
    .yanzhengma_erro {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin-top: 3px;
      .yanzheng_cuowu {
        font-size: 14px;
        color: #f56c6c;
        font-family: "MicrosoftYaHei";
        margin-left: 50px;
      }
      .yanzheng_time_lodaing {
        font-size: 14px;
        color: #909399;
        font-family: "MicrosoftYaHei";
        margin-right: 50px;
      }
    }
    .login_wrap_for_enter {
      margin-left: 50px;
      margin-top: 12px;
      .login_wrap_for_enter_con {
        width: 260px;
        line-height: 30px;
        text-align: center;
        background-color: #3366ff;
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="less">
#security_code_wrap_form {
  .el-input--suffix .el-input__inner {
    height: 30px;
    padding: 0;
    padding-left: 11px;
    display: block;
    margin-right: 11px;
    font-size: 14px;
  }
  .el-input__icon {
    line-height: 30px;
  }
  .el-input__inner {
    padding: 0;
    margin: 0;
    width: 100%;
    padding-left: 11px;
    border-radius: 3px;
    height: 30px;
    font-size: 14px;
  }
  .yanzhengdisplays .el-input__inner {
    border-color: #f56c6c;
  }
  .colorerro .el-input__inner {
    border-color: #f56c6c;
  }
  .yanzhengma_bor_btn {
    .el-button:focus,
    .el-button:hover {
      color: #3366ff;
      border-color: #ccc;
      background-color: none;
      background-color: #ffffff;
    }
  }
  .country_select {
    .el-input__inner {
      height: 24px;
    }
    .el-input__icon {
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/school_join.vue